$(document).ready(function() {
    /** STICKY FOOTER NEWSLETTER ANMELDUNG **/

    setTimeout(function() {
        $("#ttgFooterNewsletterFlyIn").removeClass("ttgDisplayNone");
    }, 1500);

    // Beim Scrollen anzeigen bzw. ausblenden
    toggleNewsletterFlyIn();

    /** // STICKY FOOTER NEWSLETTER ANMELDUNG **/

    $('#newWAfooter .specialFooter > li > span').click(function(e) {
        if ($(this).closest('li').hasClass('open')) {
            $(this).closest('li').removeClass('open');
        } else {
            $(this).closest('li').addClass('open');
        }
    });

    $('#ttgRBFooter #ttgFooterWrapper span.contact-form-header').click(function(e) {
        if ($(this).parent().hasClass('open')) {
            $(this).parent().removeClass('open');
        } else {
            $(this).parent().addClass('open');
        }
    });

    /* Individueller Footer */
    // Footer-Content positionieren
    if ($('#ttg-individual-footer-container').length > 0) {
        if ($('#ttg-individual-footer').length > 0) {
            $('#ttg-individual-footer').appendTo("#ttg-individual-footer-container");
            $('#ttg-individual-footer').fadeIn('slow');
        }
    }

});

function toggleNewsletterFlyIn() {

    if ($.cookie('showNewsletterFlyIn') != "false") {
        $(window).scroll(function() {
            if ($(window).scrollTop() > 1100) {
                if ($.cookie('showNewsletterFlyIn') != "false") {
                    if ($("#ttgFooterNewsletterFlyIn").length) {
                        $("#ttgFooterNewsletterFlyIn").show();
                        $("#ttgFooterNewsletterTeaserSymbol").hide();
                    }
                }

                $(".ttgFooterNewsletterClose a").click(function() {
                    $.cookie('showNewsletterFlyIn', 'false', {
                        expires: 0,
                        path: '/'
                    });
                    $("#ttgFooterNewsletterFlyIn").hide();
                });
            } else {
                if ($.cookie('showNewsletterFlyIn') != "false") {
                    $("#ttgFooterNewsletterFlyIn").hide();
                    $("#ttgFooterNewsletterTeaserSymbol").show();
                }
            }
        });
    }

}